import "./index.scss";
import { ImageIconProps } from "./types";
import IconDynamic from "components/Icon/IconDynamic";
import Image from "../Image";
import React from "react";
import cn from "classnames";

const ImageIcon = ({
  customClass,
  iconType,
  svgLibrary,
  svgColor,
  svgBackground,
  svgTypeImage = false,
  image,
}: ImageIconProps) => {
  const classEl = cn(
    "ImageIcon",
    {
      [`bg--${svgBackground}`]: !!svgBackground,
      [`text-${svgColor}`]: !!svgColor,
    },
    customClass,
  );
  let imageToRender = null;

  if (iconType === "svgDesign" && svgLibrary) {
    imageToRender = <IconDynamic name={svgLibrary} />;
  } else if (iconType === "image" && image) {
    imageToRender = <Image {...image} />;
  }

  return imageToRender !== null ? (
    <div className={classEl}>{imageToRender}</div>
  ) : null;
};

export default ImageIcon;
